import { render, staticRenderFns } from "./ServiceDelivery.vue?vue&type=template&id=e1af562a&"
import script from "./ServiceDelivery.vue?vue&type=script&lang=js&"
export * from "./ServiceDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports